import { useMemo } from 'react'

import { DEFAULT_BOXES, TAPERED_DISCOUNT_BOXES, TAPERED_PROMO_CODE } from '../config/discountBoxes'

export const usePaidSearchBrandDiscountBoxes = (promoCode?: string | string[]) =>
  useMemo(() => {
    const normalisedPromoCode = Array.isArray(promoCode) ? promoCode[0] : promoCode

    return normalisedPromoCode?.toUpperCase() === TAPERED_PROMO_CODE
      ? TAPERED_DISCOUNT_BOXES
      : DEFAULT_BOXES
  }, [promoCode])
